import { render, staticRenderFns } from "./plus-minus.vue?vue&type=template&id=1ec7c9f4&"
import script from "./plus-minus.vue?vue&type=script&lang=js&"
export * from "./plus-minus.vue?vue&type=script&lang=js&"
import style0 from "./plus-minus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports